import styled from "styled-components";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

type DirectionType = "top" | "right" | "bottom" | "left";

interface ChevronProps {
  direction: DirectionType;
}

export const Chevron = styled.div<ChevronProps>`
  border-style: solid;
  border-width: 0.125rem 0.125rem 0 0;
  height: 0.75rem;
  width: 0.75rem;
  transition: all 0.25s ease-in-out;

  transform: ${(p) => p.direction === "top" && "rotate(-45deg)"};
  transform: ${(p) => p.direction === "right" && "rotate(45deg)"};
  transform: ${(p) => p.direction === "bottom" && "rotate(135deg)"};
  transform: ${(p) => p.direction === "left" && "rotate(-135deg)"};
`;

interface AccordionWrapperProps {
  width?: string;
  maxHeight?: string;
}
export const AccordionWrapper = styled.div<AccordionWrapperProps>`
  background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 1.25rem;
  width: ${({ width = "875px" }) => width};
  overflow-y: auto;
  max-height: ${({ maxHeight = "750px" }) => maxHeight};

  & + & {
    margin-top: -0.125rem;
  }
`;

export const AccordionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.25;
  cursor: pointer;
  margin: 15px 0;
  color: ${DIGIPOSTHEME.colors.secondaryGraySecondary};
`;

export const AccordionContentWrapper = styled.div<{ maxHeightRef: number }>`
  max-height: ${(p) => `${p.maxHeightRef}px`};
  transition: max-height 0.7s ease-in-out;
  overflow: hidden;
`;

export const AccordionContent = styled.div`
  padding: 0 0 1rem;
  color: rgba(0, 0, 0, 0.75);
  line-height: 1.5;
`;
